import React from 'react';
import { t } from 'i18n';
import { styled, ThemeProps, Body, Caption, Currency } from '@teko/ds-desktop';
import { IComboProduct } from 'types';
import CartComboHeader from './CartComboHeader';
import { useCartV2 } from 'contexts';
import { CartItem } from '@teko/cart/v2';
import { getTrackingData } from '@teko/tracking';
import { useFormatNumber } from 'hooks';

interface CartComboSuggestListProps
  extends React.HTMLAttributes<HTMLDivElement> {
  item: CartItem;
  productsCombo: IComboProduct;
  onAddComboProduct: () => void;
  children?: React.ReactNode;
  index: number;
}

const StyledAddComboButton = styled(Body)(
  ({ theme }: ThemeProps) => `
    cursor: pointer;
    color: ${theme?.colors.link500};
    font-weight: 400;
  `,
);

const CartComboSuggestList = (props: CartComboSuggestListProps) => {
  const {
    item,
    productsCombo,
    onAddComboProduct,
    children,
    index,
    ...tracking
  } = props;

  const { onRemoveItem, onSelectItem } = useCartV2();
  const formatNumber = useFormatNumber();

  const headerButton = (
    <div
      {...getTrackingData({
        isTrackContent: true,
        contentName: 'btnAddProductCombo',
        regionName: 'cartItem',
        index: index,
        payload: JSON.stringify({
          comboPromotion:
            item.promotions &&
            item.promotions.length > 0 &&
            item.promotions[0].promotions.length > 0
              ? item.promotions[0].promotions[0].promotionId
              : null,
        }),
      })}
    >
      <StyledAddComboButton onClick={onAddComboProduct}>
        {t('Mua thêm')}
      </StyledAddComboButton>
    </div>
  );

  return (
    <CartComboHeader
      {...tracking}
      showCheck
      key={productsCombo.sku}
      headerTitle={
        <Caption marginLeft="s4" level={1}>
          {t('Mua thêm để nhận ưu đãi')}{' '}
          {!!productsCombo.bestComboDiscount ? (
            <Currency
              value={productsCombo.bestComboDiscount}
              formattedValue={formatNumber(productsCombo.bestComboDiscount)}
              weight="bold"
            />
          ) : null}
        </Caption>
      }
      headerButton={productsCombo.combos.length > 0 ? headerButton : undefined}
      checked={item.isSelected}
      onChange={() => {
        onSelectItem(item);
      }}
      onRemoveCombo={async () => onRemoveItem(item)}
    >
      {children}
    </CartComboHeader>
  );
};

export default CartComboSuggestList;
